import DashboardLayout from "@/pages/layouts/DashboardLayout";

let redirectionRoutes = {
  path: '/redirection-pages',
  component: DashboardLayout,
  redirect: '/redirection-pages/create',
  children: [
    {
      path: 'create',
      name: 'Add Redirection Page',
      component: () => import(/* webpackChunkName: "redirection-pages" */  '@/pages/pages/RedirectionForm'),
      meta: {
        permissionsCodes: ['redirection-pages/create'],
      }
    },
    {
      path: 'edit/:id',
      name: 'Edit Redirection Page',
      component: () => import(/* webpackChunkName: "redirection-pages" */  '@/pages/pages/RedirectionForm'),
      meta: {
        permissionsCodes: ['redirection-pages/update'],
      }
    }
  ]
}

export default redirectionRoutes;
